import { FC } from "react";
import CONSTANTS from "../constants/constants.json";
import "./styles/page.css";

const { PROJECTS_DATA } = CONSTANTS;

const ProjectsPage: FC = () => {
  return (
    <div className="page">
      <h1 className="page-name">{PROJECTS_DATA.PAGE_TITLE}</h1>
      <ul className="project-list">
        {PROJECTS_DATA.PROJECTS.map((project) => (
          <li key={project.TITLE} className="project-item">
            <div className="project-header">
              <span className="project-title">{project.TITLE}</span>
              <div className="project-links">
                {project.SOURCE_CODE && (
                  <a
                    href={project.SOURCE_CODE}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="project-link"
                  >
                    {PROJECTS_DATA.SOURCE_LABEL}
                  </a>
                )}
              </div>
            </div>
            <ul className="bullet-list">
              {project.BULLETS.map((point, i) => (
                <li key={i} className="bullet-item">
                  {point}
                </li>
              ))}
            </ul>
            <p className="project-tech">{project.TECHNOLOGIES.join(" · ")}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ProjectsPage;
